import React, { useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import StationMapDashboardPanel from '../../../station/components/dashboard/component/map/StationMapDashboardPanel'
import LinkedStationsPanel from '../../../station/components/associatedStation/LinkedStationsPanel'
import LastEventPanel from '../../../station/components/event/LastEventPanel'
import ContactCard from '../../../referencial/components/contact/components/ContactCard'
import StationUpdatePanel from '../../../station/components/update/StationUpdatePanel'
import InstallationInfosPanel from '../installations/components/InstallationInfosPanel'
import StationUsagePanel from '../../../station/components/link/StationUsagePanel'
import StationArrangementPanel from '../../../station/components/link/StationArrangementPanel'
import InstallationComElecPanel from '../installations/components/InstallationComElecPanel'
import InstallationAccessSitePanel from '../installations/components/InstallationAccessSitePanel'
import InstallationAccessCasingPanel from '../installations/components/InstallationAccessCasingPanel'
import StationLocationInfoPanel from '../../../station/components/location/StationLocationInfoPanel'
import InstallationStaffSafetyPanel from '../installations/components/InstallationStaffSafetyPanel'
import { getVisitSelectChange } from '../../../utils/VisitUtils'
import LocalisationMapModal from '../installations/components/modal/LocalisationMapModal'
import StationSamplersPanel from 'station/components/link/StationSamplersPanel'
import { AGRI } from 'administration/components/user/constants/HabilitationConstants'
import StationContributorPanel from '../../../station/components/link/StationContributorPanel'
import InstallationDataOriginPanel from './InstallationDataOriginPanel'
import { Card, CardContent, Grid } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { isDisplayed } from 'utils/InstallationUtils'
import { shallowEqual, useSelector } from 'react-redux'

const GenericInstallationDescription = ({
    readMode = false,
    installation = {},
    onChangeInstallation = () => { },
    onChangeVisit,
    descElements,
    otherElements,
    linkedStationTypes,
}) => {
    const {
        applicationSettings,
        contacts,
        accountHabilitations,
        installationEvents,
        installation: installationProps,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
        contacts: store.ContactReducer.contacts,
        accountHabilitations: store.AccountReducer.accountHabilitations,
        installationEvents: store.InstallationReducer.installationEvents,
        installation: store.InstallationReducer.installation,
    }), shallowEqual)

    const [localizeMap, setLocalizeMap] = useState(false)
    // const { installation, readMode, localizeMap } = this.state
    // const { accountHabilitations, applicationSettings } = this.props
    const mode = { readMode, editMode: !readMode }
    const params = {
        station: installation,
        onChange: onChangeInstallation,
        onChangeVisit,
        readMode,
    }

    return (
        <Grid container spacing={1} sx={{ marginBottom: '100px', padding: '10 10 0 20' }} alignItems='flex-start'>
            <Grid container size={9} columnSpacing={1}>
                <Grid size={12}>
                    <Card>
                        <CardTitle title={i18n.description} />
                        <CardContent>
                            <Grid container columnSpacing={1}>
                                <InstallationInfosPanel {...params} />
                                {descElements}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                {otherElements}
                {isDisplayed(applicationSettings, 'ELEC_COM', installation.installationType) && (
                    <Grid size={12}>
                        <InstallationComElecPanel {...params} />
                    </Grid>
                )}
                {isDisplayed(applicationSettings, 'ACCESS_SITE', installation.installationType) && (
                    <Grid size={12}>
                        <InstallationAccessSitePanel {...params} />
                    </Grid>
                )}
                {isDisplayed(applicationSettings, 'ACCESS_CASING', installation.installationType) && (
                    <Grid size={12}>
                        <InstallationAccessCasingPanel {...params} />
                    </Grid>
                )}
                {isDisplayed(applicationSettings, 'STAFF_SAFETY', installation.installationType) && (
                    <Grid size={12}>
                        <InstallationStaffSafetyPanel {...params} />
                    </Grid>
                )}
                {isDisplayed(applicationSettings, 'CONTRIBUTORS', installation.installationType) && (
                    <Grid size={12}>
                        <StationContributorPanel {...params} />
                    </Grid>
                )}
                {isDisplayed(applicationSettings, 'USAGES', installation.installationType) && (
                    <Grid size={12}>
                        <StationUsagePanel {...params} />
                    </Grid>
                )}
                {isDisplayed(applicationSettings, 'ARRANGEMENTS', installation.installationType) && (
                    <Grid size={12}>
                        <StationArrangementPanel {...params} />
                    </Grid>
                )}
                {accountHabilitations.some((h) => h.habilitation === AGRI) && isDisplayed(applicationSettings, 'SAMPLERS', installation.installationType) && (
                    <Grid size={12}>
                        <StationSamplersPanel {...params} />
                    </Grid>
                )}
            </Grid>
            <Grid container size={3} columnSpacing={1}>
                <Grid size={12}>
                    <StationUpdatePanel station={installation} />
                </Grid>
                <Grid size={12}>
                    <InstallationDataOriginPanel {...params} />
                </Grid>
                <Grid size={12}>
                    <ContactCard
                        title={i18n.contact}
                        contactCode={installation.ownerCode}
                        onChange={v => {
                            onChangeInstallation({ ownerCode: v })
                            onChangeVisit(getVisitSelectChange(contacts, 'code', i18n.contact, installation.ownerCode, v))
                        }}
                        readMode={readMode}
                    />
                </Grid>
                <Grid size={12}>
                    <LastEventPanel
                        id={installation.id}
                        events={installationEvents}
                        stationId={installation.id}
                        stationType='installation'
                    />
                </Grid>
                <Grid size={12}>
                    <Card>
                        <CardTitle
                            title={i18n.map}
                            actions={
                                !readMode ?
                                    [{
                                        icon: 'my_location',
                                        onClick: () => setLocalizeMap(true),
                                    }] : []
                            }
                        />
                        <StationMapDashboardPanel noMarkerTooltip station={installationProps} type={'installation'} />
                        <LocalisationMapModal
                            onChangeInstallation={onChangeInstallation}
                            installation={installation}
                            readMode={readMode}
                            open={localizeMap}
                            onClose={() => setLocalizeMap(false)}
                        />
                    </Card>
                </Grid>
                <Grid size={12}>
                    <Card>
                        <CardTitle title={i18n.localisation} />
                        <CardContent>
                            <StationLocationInfoPanel
                                onChange={onChangeInstallation}
                                onChangeVisit={onChangeVisit}
                                station={installation}
                                readMode={readMode}
                            />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={12}>
                    <LinkedStationsPanel
                        noMargin={false}
                        station={installation}
                        filteredStations={linkedStationTypes}
                        {...mode}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

GenericInstallationDescription.propTypes = {
    installation: PropTypes.object, // DtoInstallation
    readMode: PropTypes.bool,
    onChangeInstallation: PropTypes.func,
    onChangeVisit: PropTypes.func, // used for changes on visit mode only
    descElements: PropTypes.element, // specific description elements
    otherElements: PropTypes.element, // other specific elements
    linkedStationTypes: PropTypes.arrayOf(PropTypes.string), // CaptureDescriptionPanel
}

export default GenericInstallationDescription
